// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/images/tips-icon-2.png");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".no-margin>.tips-icon[data-v-25fdef82]{margin:0}.tips-icon[data-v-25fdef82]{display:inline-block;width:16px;height:16px;background:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");cursor:pointer;vertical-align:top}img[data-v-25fdef82]{width:162px;height:102px}", ""]);
// Exports
module.exports = exports;
